import GroupSubscriptionPage, { getServerSideProps } from '@haaretz/s-pp-groupSubscription-page';

export default GroupSubscriptionPage;

export { getServerSideProps };
